import { render, staticRenderFns } from "./SalepointsDialog.vue?vue&type=template&id=f08bd576&scoped=true&"
import script from "./SalepointsDialog.vue?vue&type=script&lang=js&"
export * from "./SalepointsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08bd576",
  null
  
)

export default component.exports